import { IBrowser, IDevice } from 'ua-parser-js';
import { ANSWER_TYPES } from './jobInterface';

export interface IVideoDimensions {
  width: number;
  height: number;
}

export interface IVideoPlatformOS {
  architecture: number;
  family?: string;
  version?: string;
}

export interface IVideoPlatform {
  description: string;
  layout?: string;
  manufacturer: null;
  name?: string;
  prerelease: null;
  product?: string;
  ua: string;
  version?: string;
  os: IVideoPlatformOS;
  device: IDevice;
  browser: IBrowser;
}

export interface IVideoFile {
  completed: boolean; // const false, <updatable>
  uploaded: boolean; // const false, updated automatically
  filename: string; // <new>
  retakes: number; // const 0, <updatable>
  started: boolean; // const false, <updatable>
  videoLength?: number; // none <updatable>
  uploadUrl?: string; // <new>
  question?: string; // job -> suggested
  selectedTake?: number;
  originalDimensions?: IVideoDimensions;
  //   transcoded: boolean; // none
  //   transcodingError?: string; // none
  //   type?: string; // none
  //   isAndroidSdk?: boolean; // suggested -> const false, <updatable>
  //   exported?: boolean; // none
  //   isMobile?: boolean; // suggested -> none, <updatable>
  //   rescued?: boolean; // none
  //   hasTranscript?: boolean; // none
  //   fileId?: string; // none
  //   renamed?: boolean; // none
  //   sources?: { // none
  //     src: string;
  //     type: string;
  //   }; // none
  //   transcript?: ITranscript | string; // none
  //   language?: string; // job -> suggested
  //   thumbnail?: string; // none
  //   poster?: string; // none
  //   textTracks?: { // none
  //     kind: string;
  //     label: string;
  //     language: string;
  //     src: string;
  //     default: boolean;
  //   }[]; // none
}

export interface IVideoFileDefault extends IVideoFile {
  answerType?: ANSWER_TYPES.VIDEO;
}

export interface IMultipleAnswer {
  id: string;
  label: string;
  selected: boolean;
}

export interface IVideoFileTextAnswer extends IVideoFile {
  answerType: ANSWER_TYPES.TEXT;
  answer: string;
}

export interface IVideoFileMultipleAnswer extends IVideoFile {
  answerType: ANSWER_TYPES.MULTIPLE;
  answer: IMultipleAnswer[];
}

export interface IVideoFileSingleAnswer extends IVideoFile {
  answerType: ANSWER_TYPES.SINGLE;
  answer: IMultipleAnswer[];
}

export type ALL_VIDEO_FILE_TYPES =
  | IVideoFileDefault
  | IVideoFileTextAnswer
  | IVideoFileMultipleAnswer
  | IVideoFileSingleAnswer;

export type ASSESSMENT_VIDEO_FILE_TYPES = Exclude<ALL_VIDEO_FILE_TYPES, IVideoFileDefault>;

export type CURRENT_QUESTION_ANSWER_TYPES = ASSESSMENT_VIDEO_FILE_TYPES['answer'];

export interface IVideo {
  video_id?: string; // trusted candidate -> <new>
  bandwidth?: string; // suggested <updatable>
  clicked?: boolean; // const true
  started?: boolean; // const false
  completed?: boolean; // const false (when creating, when patching verify and toggle) <updatable>
  uploaded?: boolean; // const false (when creating, when patching verify and toggle)
  jobID?: string; // {deprecated} candidate -> job -> suggested(must be checked) -> <load default job> -> <new default job>
  platform?: IVideoPlatform; // suggested <updatable>
  quality?: string; // suggested <updatable>
  referrer?: string; // suggested <updatable>
  cvUrl?: string; // suggested
  videos?: ALL_VIDEO_FILE_TYPES[]; // build from job -> untrusted job -> suggested
  processTime?: number; // suggested
  files?: string[]; // suggested
  personalInfo?: Record<string, string>; // suggested fields
  language?: string; // candidate -> job -> apiKey -> suggested
  gdprTimestamp?: string; // suggested -> <now> <updatable>
  tracking?: {
    reminder: number;
    source: number;
  };
  region?: 'us' | 'eu' | 'au' | 'london';
  widget_version?: string,
  //   job_id: string; // candidate -> job -> suggested(must be checked) -> <load default job> -> <new default job>
  //   apiKey: string; // apiKey!
  //   company_id: string; // apiKey!
  //   sharing_enabled: boolean; // unknown, so const true
  //   email: string; // candidate -> suggested
  //   ip: string; // <REQ>
  //   location: string; // const 'US'
  //   role: string; // unknown, but seems to be arbitrary from suggested
  //   serverVersion: string; // const <PKG_VERSION> + 1
  //   username: string; // candidate -> suggested
  //   shareCode: string; // <new>
  //   toDelete: boolean; // none
  //   isFake: boolean; // const false
  //   isPublic: boolean; // candidate -> const true
  //   isDev: boolean; // <ENV>
  //   webhookSavedSuccess?: boolean; // none
  //   webhook: IVideoWebhook; // none
  //   deleted?: boolean; // none
  //   filesAnalytics?: string; // unknown, const []
  //   candidate_id: string; // candidate -> suggested (with job/company verification) -> <new>
  //   run: boolean; // unknown, so const false
  //   time_viewed: number; // const 0
  //   notes: INote[]; // const []
  //   likes: IVideoLike[]; // const []
  //   commentsArr: IVideoComment[]; // const []
  //   ratingsArr: IVideoRating[]; // const []
  //   personalities?: ITextEmotions; // none
  //   ranking?: number; // unknown, so none
  //   candidate_location: string; // resolve from IP
  //   limit: {
  //     isOverLimit: boolean;
  //     length: number;
  //   }; // none!
  //   unlockedAt?: Date; // none!
  //   status: string; // const 'candidate'
  //   statusId?: string; // kanban col id: job(default) -> none
  //   integration_id?: string; // candidate -> job -> none
  //   integration_name?: string; // candidate -> job -> none
  //   updatedAt: Date | string | number; // const <now>
  //   createdAt: Date | string | number; // const <now>
}

export const enum VIDEO_STATUS {
  INCOMPLETED,
  COMPLETED,
  UPLOADED,
}
